import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormGroup, Table} from 'reactstrap';
import store from '../store';
import helpers from "../containers/helpers";

class OrdersTable extends Component {
    constructor(props) {
        super(props);

        this.lang = props.lang;
        this.onOrderRemove = props.onOrderRemove;

        this.unsubscribe = store.subscribe(() => {
            this.orders = store.getState().orders;
            this.forceUpdate();
        }).bind(this);
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    componentDidUpdate() {
        helpers.updateHeight();
    }

    render() {
        if (typeof this.orders === 'undefined')
            return null;

        let langTable = this.lang.serviceOrdered.table;
        let langOrder = this.lang.service.elem;

        return (
            <FormGroup>
                <Table className={"table-bordered table-sm table-responsive-xs table-responsive-md"} hover>
                    <thead>
                        <tr>
                            <th>{langTable.th.pos}</th>
                            <th>{langTable.th.name}</th>
                            <th>{langTable.th.details}</th>
                            <th>{langTable.th.deadline}</th>
                            <th>{langTable.th.price}</th>
                            <th>{langTable.th.delete}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.orders.map((order, i) => (
                            <tr key={i}>
                                <th scope="row">{i + 1}</th>
                                <td>{langOrder[order.name].label}</td>
                                <td>
                                    {(() => {
                                        if (typeof order.details.details === 'object') {
                                            let details = Object.values(order.details.details);
                                            return details.length > 1 ? <ul>{details.map((detail, i) => (<li key={i}>{detail}</li>))}</ul> : details[0];
                                        } else
                                            return order.details.details;
                                    })()}
                                </td>
                                <td>
                                    {(() => {
                                        let deadline = langTable.td[order.name].deadline;
                                        if (typeof order.details.details === 'object')
                                            return helpers.calcTotal(order.details.details, langTable.td[order.name].deadline, true);
                                        else if ('days' in deadline)
                                            return !isNaN(deadline.days) || typeof deadline.days === 'string' ? deadline.days + ' ' + deadline.value : null;
                                        else
                                            return null;
                                    })()}
                                </td>
                                <td>
                                    {(() => {
                                        let price = langTable.td[order.name].price;
                                        if (typeof order.details.details === 'object')
                                            return helpers.calcTotal(order.details.details, langTable.td[order.name].price, false);
                                        else if ('price' in price)
                                            return !isNaN(price.price) || typeof price.price === 'string' ? price.price + ' ' + price.value : null;
                                        else
                                            return null;
                                    })()}
                                </td>
                                <td><i className="glyphicon glyphicon-remove" aria-hidden="true" data-ordername={order.name} onClick={this.onOrderRemove}></i></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </FormGroup>
        )
    }
}

OrdersTable.propTypes = {
    lang: PropTypes.object.isRequired,
    onOrderRemove: PropTypes.func.isRequired
};

export default OrdersTable;


// WEBPACK FOOTER //
// ./src/app/components/OrdersTable.js